// extracted by mini-css-extract-plugin
module.exports =  {"narrow":"style-module_narrow__hmPLM_mkikfZgcxFf_rZ","checkboxGroup":"style-module_checkboxGroup__ClvSk5AQJhjeqsj3av1W","checkbox":"style-module_checkbox__DwlRpwYElf0Y4RLg0SOb"};